import React, { useEffect, useState } from "react";
import styles from "../Aif/Aif.module.css";
import Mail from "../../commomComponents/mail";
import ReactHtmlParser from "react-html-parser";
import getAifDetails from "../../services/request/aif";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import { Card, CardContent } from "@material-ui/core";
import star_image from "../../assets/images/star-white.svg";
import call_xs from "../../assets/images/call-xs.svg";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import Loader from "../../commomComponents/Loader";
import SeoHelmet from "../../commomComponents/seoHelmet";

export default function Aif() {
  const [main, setMain] = useState({
    image: "",
    title: "",
    detail1: "",
    details2: "",
    subHeading1: "",
    subHeading2: "",
    subHeading3: "",
  });
  const [category, setCategory] = useState([]);
  const [disclaimer, setDisclaimer] = useState("");
  const [loader, setLoder] = useState(false);

  useEffect(() => {
    const aif = getAifDetails();
    setLoder(true);
    aif.then((data) => {
      console.log(data);
      setMain(data.data.main);
      // setDisclaimer(data.data.main[0]?.disclaimer[0]);
      setCategory(data.data.categories.sort((a, b) => a.id - b.id));
      main["image"] = data.data.main[0].image;
      main["detail1"] = data.data.main[0].detail1;
      main["details2"] = data.data.main[0].details2;
      main["subHeading1"] = data.data.main[0].subHeading1;
      main["subHeading2"] = data.data.main[0].subHeading2;
      main["subHeading3"] = data.data.main[0].subHeading3;
      main["title"] = data.data.main[0].title;
      setMain({ ...main });
      setLoder(false);
    });
  }, []);

  return (
    <>
      <SeoHelmet
        title="Alternate Investment Funds & Wealth Management Services in India | ICICI Pru Alternates"
        description="Alternative Investment Funds refers to private investments done in private equity, real estate, & hedge funds. Explore ICICI PRU Alternatives AIF schemes."
        url="https://www.iciciprualternates.com/alternative-investment-funds"
      />
      <div>
        {loader === true ? (
          <Loader />
        ) : (
          <>
            <Mail />
            {/* <div className={styles.banner_section}>
            {main["image"] && (
              <BannerWithHeading
                bannerImage={IMAGE_URL + main["image"] + SITE_ID}
                heading={main["title"]}
              />
            )}
          </div> */}
            <div className={styles.imageBanner}>
              {main["image"] && (
                <img
                  src={IMAGE_URL + main["image"] + SITE_ID}
                  alt="Alternative Investment Funds (AIF)"
                />
              )}
            </div>
            <div className={styles.section1}>
              <div>
                <p className={styles.heading1}>{main["subHeading1"]}</p>
                <p className={styles.detail1}>
                  {ReactHtmlParser(main["detail1"])}
                </p>
              </div>
            </div>
            {/* <div className={styles.section2}>
        <div>
          <p className={styles.heading2}>{main["subHeading2"]}</p>
          <p className={styles.detail2}>{ReactHtmlParser(main["details2"])}</p>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.header}>{main["subHeading3"]}</div>
        <div className={styles.content}>
          {category.map((data) => (
            <Card variant="outlined" className={styles.card}>
              <CardContent>
                <div className={styles.card_content}>
                  <img src={star_image} alt="" />
                  <span className={styles.card_title}>{data.title}</span>
                </div>
                <span className={styles.card_description}>
                  <div className={styles.listStyle}>
                    {ReactHtmlParser(data.description)}
                  </div>
                </span>
              </CardContent>
            </Card>
          ))}
        </div>
      </div> */}
            <div>
              <Card className={styles.card} variant="outlined">
                <CardContent>
                  <div className={styles.card_content}>
                    <img
                      className={styles.card_content_img}
                      src={star_image}
                      alt="schemes under category 2 AIFs"
                      loading="lazy"
                    />
                    <span className={styles.card_title}>
                      {category[1]?.title}
                    </span>
                  </div>
                  <div className={styles.card_content_list}>
                    {ReactHtmlParser(category[1]?.description)}
                  </div>
                </CardContent>
              </Card>
            </div>

            <div>
              <Card className={styles.card} variant="outlined">
                <CardContent>
                  <div className={styles.card_content}>
                    <img
                      className={styles.card_content_img2}
                      src={star_image}
                      alt=""
                      loading="lazy"
                    />
                    <span className={styles.card_title}>
                      {category[2]?.title}
                    </span>
                  </div>
                  <div className={styles.card_content_list2}>
                    {ReactHtmlParser(category[2]?.description)}
                  </div>
                </CardContent>
              </Card>
            </div>
            <div>
              <p className={styles.MinimumTexts}>
                Minimum Investment Amount is required to be met before for
                investing in to Alternative Investment Funds as per SEBI (AIF)
                Regulations, 2012.
              </p>
            </div>
            <div>
              <div className={styles.disclaimer}>
                <div className={styles.disclaimerChild}>
                  <p style={{ display: "contents" }}>
                    <span className={styles.call_img}>
                      <img src={call_xs} alt="" />
                    </span>
                    <p>
                      For more information, please email at{" "}
                      <a
                        style={{
                          color: "inherit",
                        }}
                        href="mailto:FeedbackPMS@icicipruamc.com"
                      >
                        <u>alt@icicipruamc.com</u>
                      </a>
                      .
                    </p>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className={styles.policy_note}>
                {/* <h1 className={styles.policy_title}>Private and Confidential</h1> */}
              </div>
              <div>
                <p className={styles.small_text}>
                  The contents of this webpage are only for information purpose.
                  The contents of this website should not be considered as an
                  advertisement and are not an offer for sale or solicitation
                  for investments in any of the scheme’s managed by the AMC. The
                  AMC takes no responsibility of updating any data/information
                  in this material from time to time. The recipient of this
                  material is solely responsible for any action taken based on
                  this material. Further, the information contained herein
                  should not be construed as forecast or promise. The recipient
                  of this material is urged to read the Private Placement
                  Memorandum (PPM) and is advised to consult their own legal and
                  tax consultants/advisors before making any investment in the
                  Alternative Investment Fund.
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
